import { render, staticRenderFns } from "./CollectionBanner.vue?vue&type=template&id=45b0e4a2&lang=pug&"
import script from "./CollectionBanner.vue?vue&type=script&lang=js&"
export * from "./CollectionBanner.vue?vue&type=script&lang=js&"
import style0 from "./CollectionBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b0e4a2')) {
      api.createRecord('45b0e4a2', component.options)
    } else {
      api.reload('45b0e4a2', component.options)
    }
    module.hot.accept("./CollectionBanner.vue?vue&type=template&id=45b0e4a2&lang=pug&", function () {
      api.rerender('45b0e4a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/CollectionBanner.vue"
export default component.exports